import axios from 'axios';
import { EVENT } from '../../url_constants';

export default {
    getPickupData(id, attendeeId) {
        return axios({
            method: 'GET',
            url: EVENT + "?eventId=" + id + "&attendeeId=" + attendeeId,
        });
    },
    sendPickupData(data) {
        return axios({
            method: 'POST',
            url: `${EVENT}/book`,
            data
        });
    },
    proposeNewTime(data) {
        return axios({
            method: 'POST',
            url: `${EVENT}/propose-new-time`,
            data
        });
    },
    
}